/* eslint-disable react-hooks/exhaustive-deps */
import {
  ThemeProvider,
  Theme,
  StyledEngineProvider,
} from "@mui/material";
import theme from "./theme/light";
import defaultListStore from "./framework/store/DefaultListStore";
import Scrollbars from "react-custom-scrollbars-2";
import { useQuery } from "./framework/commons/useQuery";
import { useLocation } from "react-router-dom";
import { useObservable } from "./framework/store/storeUtil";
import "./App.css";
import { FC, useCallback, useEffect, useMemo } from "react";
import { LocalStorage } from "./framework/commons/LocalStorage";
import { reaction } from "mobx";
import { getEstados, getGruposEstrutura, getLimitacoesProjetos, getRevendas, getContaUsuario, getUpload, getTermos, getCategoriasComponentes, getCidades, getFraseParceiro, pwaPromptEvent$ } from "./store/global.store";
import { InfoScreen } from "./framework/components/commons/feedbacks/InfoScreen";
import { AuthLayout } from "./framework/layouts/Auth";
import { BehaviorSubject } from "rxjs";
import { stopIntervalAlerts } from "./framework/store/ProcessarFilaMensagensStore";
import { notifierStore } from "./framework/store/NotifierStore";
import { LoginStore } from "./framework/store/LoginStore";
import { appStore } from "./framework/store/AppStore";
import { Loader } from "./framework/components/commons/Loader";
import { Confirmation } from "./framework/components/commons/dialogs/Confirmation";
import { Notifier } from "./framework/components/commons/dialogs/Notifier";
import { Main } from "./framework/layouts/Main";
import { standAlonePage$ } from "./framework/store/ApiEvents";
import * as Sentry from "@sentry/react";

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const replayEnabled = process.env.REACT_APP_SENTRY_REPLAY?.toUpperCase() === "TRUE";

Sentry.init({
  dsn: String(process.env.REACT_APP_SENTRY_URL),
  // Setting this option to true will send default PII data to Sentry. For example, automatic IP address collection on events
  sendDefaultPii: process.env?.REACT_APP_SENTRY_SEND_PII?.toUpperCase() === 'TRUE',
  // Filters
  ignoreErrors: process.env.REACT_APP_SENTRY_IGNORE_ERRORS?.split(";")?.map(i => i.trim())?.filter(Boolean) || [],
  // Integrations
  integrations: [...(replayEnabled ? [Sentry.replayIntegration()] : [])],
  // Tracing
  tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_RATE) ?? 0, //  Capture 100% of the transactions
  // Replay
  ...(replayEnabled && {
    replaysSessionSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE ?? "0.05"),
    replaysOnErrorSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE ?? "1.0"),
  }),
  // Environment
  environment: process.env.REACT_APP_ENV
});

const regex = /Alterações não são permitidas neste estágio/;
export const MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO = "Ação não permitida, prazo de vigência da substituição encerrado!";
export const MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA = "Não autorizado, segmento não habilitado para atuação pela revenda. Entre em contato com o atendimento comercial";
export const MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR = "Não autorizado, segmento não habilitado para atuação pelo distribuidor. Entre em contato com o atendimento comercial";

export const openRedirectVerticais$ = new BehaviorSubject<boolean>(false);
export const openRedirect$ = new BehaviorSubject<{ status: boolean; message: string; }>({ status: false, message: "" });

reaction(
  () => appStore.getError(),
  (error) => {
    if (Array.isArray(error)) {
      error = error.filter(item => !(item.includes("Projeto") && item.includes("unique")))
    }

    if (error.length === 0) return;

    const mensagemVigencia = error?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) 
    || error?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO))
    || error?.some((message:any) => message?._messageList && message?._messageList?.some((msg:any) => msg?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO)));

    const mensagemSegmentoRevenda = error?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) 
    || error?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA))
    || error?.some((message:any) => message?._messageList && message?._messageList?.some((msg:any) => msg?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA)));
    
    const mensagemSegmentoDistribuidor = error?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) 
    || error?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR))
    || error?.some((message:any) => message?._messageList && message?._messageList?.some((msg:any) => msg?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR)));
    
    if (error[0] === "Aviso sobre projetos especiais") {
      const url = error.pop()
      const content = error
      notifierStore.setNotifier({
        content: content,
        title: error.shift(),
        timeOut: 2500,
        onClose: () => notifierStore.setOpen(false),
        onSubmit: () => window.open(url, "_blank"),
      });
      notifierStore.setOpen(true);
    } else if(mensagemVigencia){
      notifierStore.setNotifier({
        content: MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO,
        title: "Atenção!",
        timeOut: 2500,
        onFinishTimeout: () => {
          window.location.href = `${window.location.origin}/projetos/menu-projetos`
        },
        onClose: () => {
          notifierStore.setOpen(false);
          window.location.href = `${window.location.origin}/projetos/menu-projetos`
        },
      });
      notifierStore.setOpen(true);
    } else if(mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
      notifierStore.setNotifier({
        content: `${mensagemSegmentoRevenda ? MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA : MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR}.`,
        title: "Atenção!",
        timeOut: 2500,
        onFinishTimeout: () => {
          window.location.href = `${window.location.origin}/projetos/menu-projetos`
        },
        onClose: () => {
          notifierStore.setOpen(false);
          window.location.href = `${window.location.origin}/projetos/menu-projetos`
        },
      });
      notifierStore.setOpen(true);    
    } else if(regex.test(error[0])){
      if(error[1] === "vertical"){
        openRedirectVerticais$.next(true);
      }else{
        openRedirect$.next({ status: true, message: error?.[0] || '' });
      }
    } else {
      notifierStore.setNotifier({
        content: error,
        title: "Aviso",
        timeOut: 2500,
        onClose: () => notifierStore.setOpen(false),
      });
      notifierStore.setOpen(true);
    }

  }
);

const App: FC = () => {
  const location = useLocation();

  const handleBeforeInstallPrompt = useCallback((event: any) => {
    event.preventDefault();
    pwaPromptEvent$.next(event)
  }, []);

  useEffect(()=> {
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
  }, [])

  useEffect(() => {
    const storageAvailable = LocalStorage.isAvailable();
    if (!storageAvailable) {
      Sentry.captureMessage("LocalStorage indisponível", {
          level: "warning",
          tags: {
            type: "local_storage",
            operation: "availability_check"
          }
        }
      );
    }
  }, []);

  const propostaSimplificada: boolean = useMemo(() => {
    return location?.pathname?.includes('/propostas/simplificada/')
  }, [location.pathname]);

  const propostaDetalhada: boolean = useMemo(() => {
    return location?.pathname?.includes('/propostas/detalhada/')
  }, [location.pathname]);

  const isLoggedIn = useObservable(LoginStore.isLoggedInSubject()) || propostaSimplificada || propostaDetalhada;

  const query: any = useQuery();

  const onInit = async () => {
    const standAlone = LocalStorage.get("solar.standAlone", true);
    if (isLoggedIn && !propostaSimplificada && !propostaDetalhada) {
      getUpload();
      getEstados();
      getGruposEstrutura();
      getLimitacoesProjetos();
      getContaUsuario()
      getCidades();
      getRevendas();
      getCategoriasComponentes(true);
      getFraseParceiro();
      if (!standAlone) getTermos();

      stopIntervalAlerts();
    }
  };

  const onExit = () => {
    defaultListStore?.removeCache();
    const standAlone = LocalStorage.get("solar.standAlone", true);
    if (standAlone) {
      LocalStorage.removeAll();
    }
  };

  if (!isLoggedIn && !propostaSimplificada && !propostaDetalhada) {
    LoginStore.validateLogin();
  }

  const _login = useCallback(async () => {
    const standAlone = query.get("standalone");
    
    if (standAlone === '1') {
      LocalStorage.set("solar.standAlone", true, true)
      standAlonePage$.next(true)
    }
    
    if (!isLoggedIn) {
      try {
        const token = LoginStore.validateLogin();

        if (token) {
          LoginStore.setLoggedIn(true);
          await LoginStore.parseUserData();
        }
        return;
      } catch (error) {

      } finally {
        LoginStore.setLoggedIn(false);
      }
    }
  }, [isLoggedIn, query]);

  useEffect(() => {
    (async () => {
      if (!propostaSimplificada && !propostaDetalhada) await _login();
    })();
  }, [propostaSimplificada, propostaDetalhada, _login])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Loader />
        <Confirmation />
        <Notifier />
        <InfoScreen />
        <Scrollbars key="app-scrollbar" style={{ width: "100vw", height: "100vh" }}>
          <div className="App" style={{ paddingBottom: "81px", marginBottom: "70px" }}>

            {isLoggedIn ? (
              <Main onExit={() => onExit()} onInit={() => onInit()} />
            ) : (
              <AuthLayout />
            )}
          </div>
        </Scrollbars>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
